<div *ngIf="user ;  else doesNotExist" class="wrapper has-padding">

    <div *ngIf="showWarning" class="global-red double-bottom-space" role="alert" aria-live="assertive">
        {{ formModel.warningMessage }}
    </div>

	<form [formGroup]="form" (ngSubmit)="onSubmit()">
		<mat-form-field class="max-zoom width-400">
			<mat-label>Username</mat-label>
			<input matInput value="{{user.email}}" disabled>
		</mat-form-field>

    <div>
  		<mat-form-field class="max-zoom bottom-space width-350">
  			<mat-label id="otp-label">Please enter OTP (One Time Password)</mat-label>
  			<input matInput formControlName="otpPassword" type="password" maxlength="6" required autocomplete="off" aria-labelledby="otp-label" aria-required="true">
  			<mat-error *ngIf="otpPassword.hasError('submitError')">{{ formModel.errorMessage }}</mat-error>
  			<mat-error *ngIf="otpPassword.hasError('required')">Please enter OTP password</mat-error>
  		</mat-form-field>
    </div>

		<div class="bofa--action_bar is-taller">
			<button class="bofa--button primary large" [disabled]="!form.valid">Reset my password</button>
		</div>
	</form>
  <p><a routerLink='/login' class="bofa--button reverse">&larr;Back</a></p>
</div>
<ng-template #doesNotExist>
	Applicant Does Not Exist
</ng-template>
